import styled from '@emotion/styled';

import { css } from '@emotion/react';
import { SPACING } from '../../styles/emotion';

export const StarRatings = styled.div`
  display: flex;
`;
export const RatingsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.XXS};
`;

export const Stars = styled.div`
  display: flex;
  align-items: center;
`;

export const StarWrapper = styled.div<{ width: number; height: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  svg {
    flex-grow: 1;
    width: unset !important;
    height: unset !important;
  }
`;

export const StarOutlinePadding = css`
  padding-left: 3%;
  padding-right: 3%;
`;

export default { StarRatings, RatingsWrapper, Stars, StarWrapper };
